import { useContext } from "react";

import { PageNavigationContext } from "../providers/PageNavigation";

const usePageNavigation = () => {
  return useContext(PageNavigationContext);
};

export default usePageNavigation;
